<style>
  .MyP {
    display: block;
    text-align: center;
    min-height: 50px;
    max-height: 50px;
    line-height: 50px;
    cursor: pointer;

    color: white;
  }
</style>

<div class="col-md-12 mb-30" *ngIf="Selected_DataList_Cabinet.id==0">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Behfa Equipment Cabinets <span *ngIf="Procssing">(Updating...)</span></h5>

      <div class="row">

        <div class="col-md-3 mb-30" *ngFor="let item of DataList_Cabinet">

          <div class="card h-100">
            <div class="card-body">
              <h6> Location '{{item.title}}' </h6>
              <p> Code Number '{{item.dsc}}' </p>
              <hr>

              <div class="row">
                <div class="form-group col-md-6" (click)="Set_DeviceBehfa_List(item.active,item,1)">
                  <p style="background-color: #28a745;" class="MyP"><b>{{item.active.length}}</b> Active </p>
                </div>
                <div class="form-group col-md-6" (click)="Set_DeviceBehfa_List(item.disactive,item,2)">
                  <p style="background-color: #dc3545;" class="MyP"><b>{{item.disactive.length}}</b> Inactive </p>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6" (click)="Set_DeviceBehfa_List(item.repair,item,3)">
                  <p style="background-color: #ffc107;" class="MyP"><b>{{item.repair.length}}</b> Under Maintenance </p>
                </div>
                <div class="form-group col-md-6" (click)="Set_DeviceBehfa_List(item.calibration,item,4)">
                  <p style="background-color: #17a2b8" class="MyP"><b>{{item.calibration.length}}</b> Under Calibration </p>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-6" (click)="Set_DeviceBehfa_List(item.inDevice,item,5)">
                  <p style="background-color: #28a745;" class="MyP"><b>{{item.inDevice.length}}</b> Inside Cabinet </p>
                </div>
                <div class="form-group col-md-6" (click)="Set_DeviceBehfa_List(item.outDevice,item,6)">
                  <p style="background-color: #dc3545" class="MyP"><b>{{item.outDevice.length}}</b> Outside Cabinet </p>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


<div class="col-md-12 mb-30" *ngIf="Selected_DataList_Cabinet.id>0 && Data_Change_Operaion.id==0 && Data_Change_Operaion_Edit==0">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0" *ngIf="Selected_DataList_Cabinet_Swicher==1"> <b>Active</b> Equipment in Cabinet
        <b>{{Selected_DataList_Cabinet.title}}</b></h5>
      <h5 class="card-title border-0 pb-0" *ngIf="Selected_DataList_Cabinet_Swicher==2"> <b>Inactive</b> Equipment in Cabinet
        <b>{{Selected_DataList_Cabinet.title}}</b></h5>
      <h5 class="card-title border-0 pb-0" *ngIf="Selected_DataList_Cabinet_Swicher==3"> Equipment <b>Under Maintenance</b> in Cabinet
        <b>{{Selected_DataList_Cabinet.title}}</b></h5>
      <h5 class="card-title border-0 pb-0" *ngIf="Selected_DataList_Cabinet_Swicher==4"> Equipment <b>Under Calibration</b> in Cabinet
        <b>{{Selected_DataList_Cabinet.title}}</b></h5>
      <h5 class="card-title border-0 pb-0" *ngIf="Selected_DataList_Cabinet_Swicher==5"> Equipment <b>Inside Cabinet</b>
        <b>{{Selected_DataList_Cabinet.title}}</b></h5>
      <h5 class="card-title border-0 pb-0" *ngIf="Selected_DataList_Cabinet_Swicher==6"> Equipment <b>Outside Cabinet</b>
        <b>{{Selected_DataList_Cabinet.title}}</b></h5>

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Description</label>
          <input [(ngModel)]="Filter_Description" (keyup)="Change_Filter()" name="Description" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Manufacturer</label>
          <input [(ngModel)]="Filter_Manufacturer" (keyup)="Change_Filter()" name="Filter_Manufacturer" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Model</label>
          <input [(ngModel)]="Filter_Model" (keyup)="Change_Filter()" name="Filter_Model" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Code BEHFA</label>
          <input [(ngModel)]="Filter_Code" (keyup)="Change_Filter()" name="Filter_Code" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <button (click)="Back_DeviceBehfa_List()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i>
            Back </button>
        </div>
      </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>System ID</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>

            <tr *ngFor="let item of DataList_DeviceBehfa
            |filter:Filter_Description:'description'
            |filter:Filter_Manufacturer:'manufacturer'
            |filter:Filter_Model:'model'
            |filter:Filter_Code:'codeBEHFA'
            | paginate
            : {
                id: 'DataList_DeviceBehfaTable',
                itemsPerPage: 50,
                currentPage: page,
                totalItems: (DataList_DeviceBehfa
                |filter:Filter_Description:'description'
                |filter:Filter_Manufacturer:'manufacturer'
                |filter:Filter_Model:'model'
                |filter:Filter_Code:'codeBEHFA'
                ).length}">

              <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td class="EnglishClm">{{item.description}}</td>
              <td class="EnglishClm">{{item.manufacturer}}</td>
              <td class="EnglishClm">{{item.model}}</td>
              <td class="EnglishClm">{{item.codeBEHFA}}</td>
              <td>
                <div class="btn-group" *ngIf="item.status!=5" role="group" aria-label="Button group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a  style="cursor: pointer;" class="dropdown-item"
                        (click)="Set_Change_Operaion_Edit(item.id)"><i class="fa  fa-eye"></i> Details </a>

                      <a  style="cursor: pointer;" class="dropdown-item"
                        (click)="Set_Change_Operaion(item)"><i class="fa  fa-history"></i> Status Change History </a>
                    </div>

                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
        <br />
        <br />
        <br />
        <br />
      </div>

      <pagination-controls id="DataList_DeviceBehfaTable" nextLabel="Next" previousLabel="Previous"
        (pageChange)="page = $event"></pagination-controls>


    </div>
  </div>
</div>


<app-DeviceBehfaChangeOperation
  *ngIf="Data_Change_Operaion.id>0"
  [deviceBehfa_Innner]="Data_Change_Operaion"
  (OnBack_DeviceBehfa_Action)="OnBack_Change_Operaion($event)">
</app-DeviceBehfaChangeOperation>

<app-DeviceBehfaEdit
  *ngIf="Data_Change_Operaion_Edit>0"
  [deviceBehfa_id_Innner]="Data_Change_Operaion_Edit"
  (OnBack_DeviceBehfa_Edit_Action)="OnBack_Change_Operaion_Edit($event)">
</app-DeviceBehfaEdit>
